import { Plugin } from "prosemirror-state";
import { applyDerivedAttrs } from "../normalize";

/** Keeps text-derived attributes in step after every edit (see applyDerivedAttrs). */
export const derivedAttrsPlugin = () =>
  new Plugin({
    appendTransaction(transactions, _old, state) {
      if (!transactions.some((tr) => tr.docChanged)) return null;
      const tr = applyDerivedAttrs(state.tr);
      return tr.docChanged ? tr : null;
    },
  });
